import React from 'react';
import { Reveal } from './Reveal';
const bonuses = [{
  number: '01',
  title: 'BONO 1 — Rutinas Relámpago',
  description: 'Fichas de actividades de 5, 15 y 30 minutos, listas para imprimir y usar sin pensar.',
  price: '$11.000'
}, {
  number: '02',
  title: 'BONO 2 — El Guion de la Culpa',
  description: 'Frases y micro-guiones para los momentos de fricción: llegadas tarde, cancelaciones, distracción.',
  price: '$11.000'
}, {
  number: '03',
  title: 'BONO 3 — Calendario de Presencia',
  description: 'Planificador mensual imprimible para agendar momentos de conexión, igual que una reunión de trabajo.',
  price: '$11.000'
}];
export function BonusSection() {
  return <section aria-label="Bonos incluidos" className="w-full bg-cream-200 py-16 sm:py-24" data-id="element-20" data-mp="1eor9ke5ig11q">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-21" data-mp="qywx3xp3sei0">
        <Reveal data-id="element-22" data-mp="mzedr6cxkbha">
          <h2 className="text-center font-display text-2xl font-semibold tracking-tight text-bark-900 sm:text-3xl" data-id="element-23" data-mp="mzo1soef08kc">
            🎁 3 BONOS ESTRATÉGICOS — SIEMPRE INCLUIDOS
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-24" data-mp="2eq4ljzhw5omn">
          {bonuses.map((bonus, i) => <Reveal key={bonus.number} delay={i * 0.08} data-id="element-25" data-mp="2jixqooh9uyz9" data-mpi={i}>
              <article className="flex h-full flex-col rounded-3xl border border-terracotta-300/40 bg-cream-50 p-6 shadow-sm" data-id="element-26" data-mp="2ogzhxwouq4lt">
                <span className="font-display text-3xl font-semibold text-terracotta-300" data-id="element-27" data-mp="1qu0jbgelmmla">
                  {bonus.number}
                </span>
                <h3 className="mt-3 font-display text-lg font-semibold leading-snug text-bark-900" data-id="element-28" data-mp="1vueg22ar2a40">
                  {bonus.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-bark-600" data-id="element-29" data-mp="25qrjvt00e4ch">
                  {bonus.description}
                </p>
                <p className="mt-5 flex items-center gap-3" data-id="element-30" data-mp="3c6aef1z65cu5">
                  <span className="text-sm font-medium text-bark-400 line-through" data-id="element-31" data-mp="3h4vaqqbavcdb">
                    {bonus.price}
                  </span>
                  <span className="rounded-full bg-sage-500 px-3 py-1 text-xs font-bold uppercase tracking-wider text-cream-50" data-id="element-32" data-mp="1h5i1eyrlkcmi">
                    Gratis
                  </span>
                </p>
              </article>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-33" data-mp="1m3tb99hw6n4q">
          <p className="mx-auto mt-8 max-w-xl rounded-full bg-bark-800 px-6 py-4 text-center font-display text-base font-semibold text-cream-100 sm:text-lg" data-id="element-34" data-mp="1m0drvuh6qrxi">
            Valor total bonos: <span className="line-through opacity-60" data-id="element-35" data-mp="tfdxeqahyauz">$33.000</span> → GRATIS con
            tu Kit
          </p>
        </Reveal>
      </div>
    </section>;
}